$eve_tab_group $eve_selection_single
	attr *
		^
		role \tablist
	sub /
		<= Layout $eve_flex
			direction \row
			wrap \nowrap
			sub <= Options /
				<= Option* $eve_tab
					label <= option_label*
					selected <= option_selected*
					event_click?event <=> option_click*?event
